<template>
    <div>
        <div class="sideMenu-title mb-2">
            접속통계
        </div>
        <div class="sideMenu">
            <div class="sideMenu-group">
                <ul style="width:100%;" class="">
                    <li class="">
                        <a :class="{active : menuActive.isActive1}" @click="menuClick('/admin/acc/day')">일별 통계</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive0}" @click="menuClick('/admin/acc/month')">월별 통계</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive2}" @click="menuClick('/admin/acc/time')">시간대별 통계</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive3}" @click="menuClick('/admin/acc/week')">요일별 통계</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive4}" @click="menuClick('/admin/acc/search')">검색엔진 통계</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive5}" @click="menuClick('/admin/acc/path')">접속경로 통계</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'AdminAccMenu',
        data: () => ({
            menuActive: {
                isActive0: false,
                isActive1: false,
                isActive2: false,
                isActive3: false,
                isActive4: false,
                isActive5: false,
                isActive6: false,
            }
        }),
        created: function () {
            this.setMenuActive();
        },
        computed: {

        },
        methods: {
            menuClick(route, gubun) {

                if(gubun != null){

                    location.href = route + '?resvGubun=' + gubun;
                }else{
                    location.href = route;
                }
            },
            setMenuActive(){
                switch (window.location.pathname) {
                    case "/admin/acc/month":{
                        this.menuActive.isActive0 = true;
                        break;
                    }
                    case "/admin/acc/day":{
                        this.menuActive.isActive1 = true;
                        break;
                    }
                    case "/admin/acc/time":{
                        this.menuActive.isActive2 = true;
                        break;
                    }
                    case "/admin/acc/week":{
                        this.menuActive.isActive3 = true;
                        break;
                    }
                    case "/admin/acc/search":{
                        this.menuActive.isActive4 = true;
                        break;
                    }
                    case "/admin/acc/path":{
                        this.menuActive.isActive5 = true;
                        break;
                    }
                }

            }
        },

    }

</script>

<style lang="scss" scoped>
    /*@import './base.scss';*/


</style>
